import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { purchaseNotifications, PURCHASE_ANCHOR } from '../data/content';
export function SalesPopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    const show = window.setTimeout(() => setVisible(true), 6000);
    return () => window.clearTimeout(show);
  }, [dismissed]);
  useEffect(() => {
    if (dismissed) return;
    const cycle = window.setInterval(() => {
      setIndex(i => (i + 1) % purchaseNotifications.length);
      setVisible(true);
    }, 15000);
    return () => window.clearInterval(cycle);
  }, [dismissed]);
  useEffect(() => {
    if (!visible || dismissed) return;
    const hide = window.setTimeout(() => setVisible(false), 6500);
    return () => window.clearTimeout(hide);
  }, [visible, index, dismissed]);
  const person = purchaseNotifications[index];
  const minutes = index * 7 % 18 + 2;
  return <AnimatePresence data-id="element-133" data-mp="24rr1tre08247">
      {visible && !dismissed ? <motion.div initial={{
      opacity: 0,
      y: 16,
      scale: 0.96
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 12,
      scale: 0.97
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-3 left-3 z-50 w-[15.5rem] max-w-[calc(100vw-1.5rem)]" data-id="element-134" data-mp="24od1spstc4zx">
          <a href={PURCHASE_ANCHOR} className="flex items-start gap-2 rounded-lg border-2 border-gold bg-white p-2 shadow-[0_10px_25px_-8px_rgba(8,47,91,0.6)] ring-2 ring-brightblue/40" data-id="element-135" data-mp="2ng5sueobng50">
            <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-confirm" strokeWidth={2.5} aria-hidden="true" data-id="element-136" data-mp="2xev1rhy8pq94" />
            <div className="min-w-0" data-id="element-137" data-mp="132dj6nocjeat">
              <p className="font-heading text-[0.68rem] font-extrabold uppercase leading-tight text-navy" data-id="element-138" data-mp="133g8ws9xnap5">
                {person.name}
              </p>
              <p className="truncate text-[0.66rem] leading-snug text-muted" data-id="element-139" data-mp="q2covny62f6b">
                {person.city}, {person.country}
              </p>
              <p className="mt-0.5 text-[0.66rem] font-semibold leading-snug text-brightblue" data-id="element-140" data-mp="14wr195n86qc0">
                just purchased CLEANING READY™
              </p>
              <p className="text-[0.6rem] font-bold uppercase tracking-wide text-gold" data-id="element-141" data-mp="1dygumh0o3zcf">
                {minutes} minutes ago
              </p>
            </div>
          </a>
          <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss notification" className="absolute -right-2 -top-2 rounded-full border-2 border-gold bg-white p-1 text-navy shadow" data-id="element-142" data-mp="1np1yaiv77u27">
            <XIcon className="h-3 w-3" aria-hidden="true" data-id="element-143" data-mp="1wnx7m3tjhk9q" />
          </button>
        </motion.div> : null}
    </AnimatePresence>;
}